<template>
  <div>
    <a-descriptions title="配置信息" :column="2">
      <a-descriptions-item label="eSIM供应商">
        {{ data.esim_supplier_name }}
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
export default {
  name: 'AgentPurchaseItemEsimConfigureInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
